export default "images/background-about.png";